import { logRemote } from '@bonanza-social/toolkit/logging';
import { startListening, trackEvent } from '@bonanza-social/toolkit/state';
import { selectRegistrationConfigVariant } from '@bonanza-social/registration/state';
import { getDeviceId, getSessionId } from '../../utils';

if (!__DEV__) {
  startListening({
    actionCreator: trackEvent,
    effect: async (action, { getState }) => {
      const { name, params = {} } = action.payload;

      if (name === 'registration_step' && 'stepId' in params) {
        const state = getState();
        const deviceId = await getDeviceId();
        const sessionId = getSessionId();
        const registrationConfigVariant =
          selectRegistrationConfigVariant(state);

        logRemote(
          `[website][registration] ${registrationConfigVariant}_${params.stepId}_${deviceId}_${sessionId}`,
        );
      }
    },
  });
}
